module.exports = __webpack_public_path__ + "images/emoji/white_circle.aad0942dee9569da7f8b.png";